export enum DeliveryBookingTypeEnum {
	Regular = 1,
	Hailed = 2,
	ScanAndRide = 3,
	Shuttle = 4,
	WalkIn = 5,
	WalkInImmediateDispatch = 6
}
